import { gql } from "@apollo/client";

export const GET_INTEGRATION = gql`
  query integration($integrationType: String!) {
    integration(integrationType: $integrationType) {
      integrationType
      integrationService
      sourceSystem
      group
      title
      url
      status
      settings {
        integrationEntitySettings {
          entityName
          entityKey
        }
      }
    }
  }
`;

export const GET_SUPPORTED_INTEGRATIONS = gql`
  query integrations {
    integrations {
      integrationType
      integrationService
      sourceSystem
      group
      title
      url
      status
      settings {
        integrationEntitySettings {
          entityName
          entityKey
        }
      }
    }
  }
`;

export const GET_INTEGRATION_TOKEN = gql`
  mutation GetIntegrationToken($type: String, $accountId: String) {
    integrationToken(type: $type, accountId: $accountId) {
      referenceId
      linkUrl
      linkToken
    }
  }
`;

export const CONNECT_INTEGRATION = gql`
  mutation ConnectIntegration($type: String, $key: String) {
    connectIntegration(type: $type, key: $key)
  }
`;

export const DISCONNECT_INTEGRATION = gql`
  mutation DisconnectIntegration($accountId: String) {
    disconnectIntegration(accountId: $accountId)
  }
`;

export const IS_INTEGRATION_CONNECTED = gql`
  query isIntegrationConnected($selectedCompanyId: ID) {
    isIntegrationConnected(selectedCompanyId: $selectedCompanyId)
  }
`;

export const REFRESH_INTEGRATIONS = gql`
  mutation RefreshIntegrations {
    refreshIntegrations
  }
`;
